import { html } from "@microsoft/fast-element";
import type { ElementViewTemplate } from "@microsoft/fast-element";
import { NatGenAccordionAnchor } from "./accordion-anchor";
import { AccordionItemOptions } from "../accordion-item/accordion-item.options";
import { endSlotTemplate, startSlotTemplate } from "../start-end/start-end";

export function accordionAnchorTemplate<T extends NatGenAccordionAnchor>(
    options: AccordionItemOptions = {}
): ElementViewTemplate<T> {
    return html<T>`
    <template>
        <div
            class="heading"
            part="heading"
            role="heading"
            aria-level="${x => x.headinglevel}"
        >
            <a
                class="button"
                part="button"
                id="${x => x.id}"
                href="${x => x.href}"
                target="${x => x.target}"
            >
                <span class="heading-content" part="heading-content">
                    <slot name="heading"></slot>
                </span>
            </a>
            ${startSlotTemplate(options)}
            ${endSlotTemplate(options)}
            <span class="expand-collapse-icon" part="icon" aria-hidden="true">
                <slot name="icon" part="icon">
                    <natgen-icon name="chevron-right"></natgen-icon>
                </slot>
            <span>
        </div>
    </template>
`};
